import { IRecommendations, RecommendationsProps } from './types';

export const mapRecommendations = ({
  prismicContent,
  position,
}: {
  prismicContent: RecommendationsProps['slice'];
  position: number;
}): IRecommendations => {
  return {
    contents: {
      widgetIdA: prismicContent.primary.widget_id_a as string,
      widgetIdB: prismicContent.primary.widget_id_b as string,
      abTestId: prismicContent.primary.ab_test_id as string,
      title: prismicContent.primary.title,
      trackingId: prismicContent.primary.tracking_id as string,
      isOnCardClickDisabled: prismicContent.primary.is_on_card_click_disabled,
      position: position,
      isProductDrawerEnabled: prismicContent.primary.is_product_drawer_enabled,
    },
  };
};
